import { useRecoilValue } from 'recoil'
import parameterGroupsAtom from '@/pages/Parameters/parameterGroups.atom.ts'
import { IParameterGroup } from '@/pages/Parameters/parameters.types.ts'
import { useMemo } from 'react'

const useParameterGroup = (id: IParameterGroup['id']) => {
  const groups = useRecoilValue(parameterGroupsAtom).items

  return useMemo(() => {
    return groups.find((g) => g.id === id)
  }, [id, groups])
}

export default useParameterGroup
